import React from 'react';
import { MarkdownBlock } from '../../../MarkdownBlock';
import { styles } from './ReturnsRefundsTab.css';

export type ReturnsRefundsTabProps = {
  returnsRefundsMarkdown: string;
};

export const ReturnsRefundsTab = ({ returnsRefundsMarkdown }: ReturnsRefundsTabProps) => {
  return <MarkdownBlock className={styles.sellerContentTabContainer}>{returnsRefundsMarkdown}</MarkdownBlock>;
};
